export default {
  'formFields': {
    'fieldHelp': 'Cliquez pour ouvrir la description',
    'defaultAbbreviation': 'df.: ',
    'paramJSONContent': 'Contenu JSON',
    'wrongInputValue': 'Mauvaise valeur d\'entrée pour ce paramètre.',
    'notValidJsonString': 'JSON non-valide pour: fieldName'
  },
}
